function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import ConfigProvider from '../config-provider';
import Button from './view/button';
import ButtonGroup from './view/group';
import IconButton from './view/icon';
Button.Group = ButtonGroup;
Button.Icon = IconButton;
export default ConfigProvider.config(Button, {
  transform:
  /* istanbul ignore next */
  function transform(props, deprecated) {
    if ('shape' in props) {
      deprecated('shape', 'text | warning | ghost', 'Button');

      var _props = props,
          shape = _props.shape,
          type = _props.type,
          others = _objectWithoutProperties(_props, ["shape", "type"]);

      var newType = type;

      if (type === 'light' || type === 'dark' || type === 'secondary' && shape === 'warning') {
        newType = 'normal';
      }

      var ghost;

      if (shape === 'ghost') {
        ghost = {
          primary: 'dark',
          secondary: 'dark',
          normal: 'light',
          dark: 'dark',
          light: 'light'
        }[type || Button.defaultProps.type];
      }

      var text = shape === 'text';
      var warning = shape === 'warning';
      props = _objectSpread({
        type: newType,
        ghost: ghost,
        text: text,
        warning: warning
      }, others);
    }

    return props;
  }
});